import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryCustomerObligation = {
  async customerObligation(parent, args, context, info) {
    const { customerNumber, sort, page, size } = args
    const { user } = context

    // If no customerNumber is provided, return safe defaults
    if (!customerNumber) {
      return { sumOpenOrders: 0, obligoWa: 0, obligoWe: 0, total: 0 }
    }

    await checkPermissions({
      user,
      domainObject: DomainObjects.OBLIGATIONS,
      operation: Operations.READ,
    })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerNumber,
    })

    const sortString = EinzaGraphiQLService.formatSortParam(sort)

    const graphiQLQueryObject = [
      {
        method: "findObligoByCustomer",
        variables: { customerNumber, page, size, ...(sort && { sort: sortString }) },
        fields: ["totalElements"],
        expandedFields: {
          content: ["companyNumber", "obligoWa", "obligoWe", "sumOpenOrders"],
        },
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findObligoByCustomer

    // If no data is returned, provide safe defaults instead of throwing
    if (!einzaResponse?.content || einzaResponse?.content?.length <= 0) {
      return { sumOpenOrders: 0, obligoWa: 0, obligoWe: 0, total: 0 }
    }

    // According to customer decision from 2024-02-02 only show the obligation data for the company 500
    // https://reply.atlassian.net/browse/EINZA-488?focusedCommentId=49088
    // Fallback: if company 500 is missing, use the first available entry; if none, use zeros
    const company500 = einzaResponse.content.find((item) => item.companyNumber === "500")
    const source = company500 || einzaResponse.content[0] || {}
    const sumOpenOrders = source?.sumOpenOrders || 0
    const obligoWa = source?.obligoWa || 0
    const obligoWe = source?.obligoWe || 0
    const total = Number(sumOpenOrders) + Number(obligoWa) + Number(obligoWe)

    return {
      sumOpenOrders: sumOpenOrders || 0,
      obligoWa: obligoWa || 0,
      obligoWe: obligoWe || 0,
      total,
    }
  },
}
